/*! bxs-vue-ui v4.0.1 */
import './normalize-component.js';
import './index.js';

function hasClass(ele, cls) {
  return new RegExp("\\b" + cls + "\\b").test(ele.getAttribute('class') || '');
}

function addClass(ele, cls) {
  if (!hasClass(ele, cls)) {
    ele.setAttribute('class', ele.getAttribute('class') + " " + cls);
  }
}
function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    ele.setAttribute('class', ele.getAttribute('class').replace(new RegExp("\\b" + cls + "\\b"), ''));
  }
}
function getContainer(appendTo) {
  var $container = null;

  if (typeof appendTo === 'string') {
    $container = document.querySelector(appendTo);
  } else if (typeof appendTo === 'object' && appendTo.nodeType === Node.ELEMENT_NODE) {
    $container = appendTo;
  }

  return $container || document.body;
}

export { addClass as a, getContainer as g, removeClass as r };
